import { Marker } from '../../../../../../../../lib/Map';
import { isDriverDelayed, formatDriverLocation } from '../../../../DriverMap/utils';
import { getDispatchDriverMarker } from '../../../../../../../mapComponents/mapHelper';
import { observer, inject } from 'mobx-react';

const DriverMarkers = ({ DispatchStore, theme, driverIds = [], showDriverLabel = false }) => {
  const { driverLocations } = DispatchStore;

  return driverIds.reduce((acc, driverId) => {
    const locationData = driverLocations[driverId];

    if (!locationData?.lat || !locationData?.lng) {
      return acc;
    }

    const driverData = DispatchStore.getCurrentDriver(driverId);
    if (!driverData) {
      return acc;
    }

    return [
      ...acc,
      <Marker
        position={formatDriverLocation(locationData)}
        zIndex={1}
        key={driverId}
        data={{ locationData, driverId }}>
        {getDispatchDriverMarker({
          data: { ...driverData, driverId },
          isDelayed: isDriverDelayed(driverData),
          showDriverLabel: { showDriverLabel },
          theme
        })}
      </Marker>
    ];
  }, []);
};

export default inject('DispatchStore')(observer(DriverMarkers));
